/**
 * Address bar helpers.
 */
export class UrlUtils {

    /**
     * Removes query parameters from the address bar without navigating (history.replaceState): the current
     * history entry no longer holds them. Used once the app has read a secret from its address (preview token
     * of the prize game). The other parameters (skip...), the fragment and the history state are kept. Then
     * lets Clarity load (window.sfLoadTrackers, index.html), which waits for an address without secret.
     * Synchronous and never throws: it runs on the boot path (app.config.ts).
     * @param names Names of the query parameters to remove
     */
    static removeQueryParamsFromAddressBar(names: string[]): void {
        try {
            const url = new URL(window.location.href);
            const present = names.filter(name => url.searchParams.has(name));
            if (!present.length) {
                return;
            }
            present.forEach(name => url.searchParams.delete(name));
            window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
            (window as { sfLoadTrackers?: () => void }).sfLoadTrackers?.();
        } catch {
            // Boot path: swallow everything.
        }
    }
}
